export default {
    venues: [
        { name: 'Angels - Angel Stadium', value: 1 },
        { name: 'Astros - Daikin Park', value: 2392 },
        { name: 'Athletics - Oakland Coliseum', value: 10 },
        { name: 'Athletics - Sutter Health Park', value: 2529 },
        { name: 'Blue Jays - Rogers Centre', value: 14 },
        { name: 'Braves - Truist Park', value: 4705 },
        { name: 'Brewers - American Family Field', value: 32 },
        { name: 'Cardinals - Busch Stadium', value: 2889 },
        { name: 'Cubs - Wrigley Field', value: 17 },
        { name: 'Diamondbacks - Chase Field', value: 15 },
        { name: 'Dodgers - Dodger Stadium', value: 22 },
        { name: 'Giants - Oracle Park', value: 2395 },
        { name: 'Guardians - Progressive Field', value: 5 },
        { name: 'Mariners - T-Mobile Park', value: 680 },
        { name: 'Marlins - Marlins Park', value: 4169 },
        { name: 'Mets - Citi Field', value: 3289 },
        { name: 'Nationals - Nationals Park', value: 3309 },
        { name: 'Orioles - Oriole Park', value: 2 },
        { name: 'Padres - Petco Park', value: 2680 },
        { name: 'Phillies - Citizens Bank Park', value: 2681 },
        { name: 'Pirates - PNC Park', value: 31 },
        { name: 'Rangers - Globe Life Field', value: 5325 },
        { name: 'Rays - Tropicana Field', value: 12 },
        { name: 'Rays - George M. Steinbrenner Field', value: 2523 },
        { name: 'Red Sox - Fenway Park', value: 3 },
        { name: 'Reds - GABP', value: 2602 },
        { name: 'Rockies - Coors Field', value: 19 },
        { name: 'Royals - Kauffman Stadium', value: 7 },
        { name: 'Tigers - Comerica Park', value: 2394 },
        { name: 'Twins - Target Field', value: 3312 },
        { name: 'White Sox - Rate Field', value: 4 },
        { name: 'Yankees - Yankee Stadium', value: 3313 },
        // // Extras
        // { name: 'Bristol Motor Speedway', value: 6130 },
        // { name: 'Braves - Turner Field', value: 16 },
        // // Doesn't work with 3D FYI
        // { name: 'Rangers - Globe Life Park', value: 13 },
    ],
}
